<template>
    <div class="cmd clearfix">
        <span class="cmd-line" v-text="onlyId"></span>
        <div class="cmd-text" v-html="formatValue"></div>
    </div>
</template>
<script>
export default {
    name: 'Cmd',
    props: {
        value: {
            type: [String, Number],
            required: true
        },
        onlyId: [String, Number]
    },
    computed: {
        formatValue() {
            return String(this.value)
                .replace(/\u001b\[(.*?)m/g, '')
                .replace(/>/g, '&gt;')
                .replace(/</g, '&lt;')
                .replace(/\n+/g, '<br>')
                .replace(/\s/g, '&nbsp;')
                .replace(/<br>$/g, '')
                .replace(/},{/g, '},<br>{')
        }
    }
}
</script>
<style lang="less">
    .cmd {
        background-color: #000;
        font-size: 12px;
        color: white;
        padding: 10px 5px 0;
        .cmd-line {
            float: left;
            width: 2.5em;
            color: rgb(179, 71, 22);
        }
        .cmd-text {
            overflow: hidden;
            word-break: break-all;
            word-wrap: break-word;
        }
    }
</style>
